// svgs
import Logo from '../../assets/svgs/logo.svg';
import Loginbg from '../../assets/svgs/Loginbg.svg';
// images

// files
import addRateCardSampleFile from '../../assets/csv/addRateCardSampleFile.csv';

export const useAssets = () => {
  return {
    // svgs
    Logo,
    Loginbg,
    // image
    // files
    addRateCardSampleFile
  };
};
